import { BaseEntity } from "@app/models/rest/base-entity";
import { Roster } from "@app/models/rest/roster/roster";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("subDivisions")
export class SubDivision extends BaseEntity {
  public name: string;
  roster: Roster;
}
